export default "__VITE_ASSET__DDmt1zeh__"